import { render, staticRenderFns } from "./InheritedIRA.vue?vue&type=template&id=60d57494&scoped=true"
import script from "./InheritedIRA.vue?vue&type=script&lang=js"
export * from "./InheritedIRA.vue?vue&type=script&lang=js"
import style0 from "./InheritedIRA.vue?vue&type=style&index=0&id=60d57494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d57494",
  null
  
)

export default component.exports